import { Outlet, createFileRoute } from '@tanstack/react-router'
import { LNavbar } from '@/components/l'

export const Route = createFileRoute('/_public')({
  component: PublicLayout,
})

function PublicLayout() {
  return (
    <>
      <LNavbar />
      <Outlet />
    </>
  )
}
